import React from "react";
import { Link } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";

function Online() {
  const { theme } = useTheme();

  return (
    <div className="container mx-auto my-8 px-4">
      <h2 className={`text-4xl font-bold mb-4 ${theme.text}`}>
        Online-Beratung
      </h2>

      <div className="max-w-4xl">
        <p className="text-lg leading-relaxed mb-6 text-slate-700">
          Die Online-Beratung bietet Ihnen die Möglichkeit, professionelle
          Unterstützung bequem von zu Hause aus in Anspruch zu nehmen. Die
          Beratung findet per Videochat statt und ist genauso vertraulich und
          professionell wie ein persönliches Gespräch.
        </p>
        <div className={`${theme.box} p-6 rounded-lg shadow-lg mb-12`}>
          <h3 className="text-xl font-semibold mb-4 text-slate-800">
            Vorteile der Online-Beratung
          </h3>
          <ul className="space-y-3 text-lg text-slate-700">
            <li>• Ortsunabhängig - keine Anfahrtswege</li>
            <li>• Zeitlich flexibel</li>
            <li>• In vertrauter Umgebung</li>
            <li>• Technisch einfach umsetzbar</li>
          </ul>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        <div className={`${theme.box} p-6 rounded-lg shadow-lg`}>
          <h3 className="text-xl font-semibold mb-4 text-slate-800">
            So funktioniert's
          </h3>
          <ol className="space-y-4 text-lg text-slate-700">
            <li>
              1. Kontaktaufnahme per E-Mail oder Telefon zur Terminvereinbarung
            </li>
            <li>2. Sie erhalten einen Link für die Videokonferenz</li>
            <li>3. Zum vereinbarten Termin klicken Sie einfach auf den Link</li>
            <li>
              4. Das Gespräch findet in einem geschützten virtuellen Raum statt
            </li>
          </ol>
          <div className="mt-6">
            <h4 className="text-lg font-semibold mb-3 text-slate-800">
              Technische Voraussetzungen:
            </h4>
            <ul className="space-y-2 text-slate-700">
              <li>• Stabile Internetverbindung</li>
              <li>• Computer/Tablet mit Kamera und Mikrofon</li>
              <li>• Ruhiger, ungestörter Raum</li>
            </ul>
          </div>
        </div>

        <div
          className={`bg-gradient-to-br ${theme.gradient} p-8 rounded-lg shadow-lg text-white`}
        >
          <h3 className="text-2xl font-bold mb-6">Kontakt aufnehmen</h3>
          <p className="text-lg mb-6">
            Haben Sie Interesse an einer Online-Beratung? Kontaktieren Sie mich
            gerne für weitere Informationen oder zur Terminvereinbarung.
          </p>
          <div className="space-y-3">
            <p className="text-lg">E-Mail: stepintochange.withlisa@gmail.com</p>
          </div>
          <Link
            to="/contact"
            className="inline-block mt-6 bg-white text-slate-800 px-6 py-3 rounded-lg hover:bg-slate-100 transition-colors shadow-md"
          >
            Zum Kontakt
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Online;
